import { useSelector } from 'react-redux';
import { getFeatureFlags } from 'core/userContext';
import { useTranslations } from '../../../hooks/useTranslations';

export const useTooltipErrorContent = (
  nbaLocalesErrors: string[],
  nbaErroredLocaleNames: string,
  allContentLocaleErrorNames: string,
) => {
  const { t } = useTranslations();
  const featureFlags = useSelector(getFeatureFlags);

  if (featureFlags.NextBestAction && nbaLocalesErrors.length > 0) {
    return nbaLocalesErrors.length > 1
      ? t('tooltip.nbaLocales', { locales: nbaErroredLocaleNames })
      : t('tooltip.nbaLocale', { locale: nbaErroredLocaleNames });
  } else {
    return allContentLocaleErrorNames.length > 1
      ? t('tooltip.errLocales', { locales: allContentLocaleErrorNames })
      : t('tooltip.errLocale', { locale: allContentLocaleErrorNames });
  }
};
